export interface BackdropOptions {
  dismissOnClick?: boolean;
}

export interface ModalOptions {
  id?: string;
  classNames?: string[] | string;
  centered?: boolean;
  backdrop?: BackdropOptions | false;
  dismissOnEscape?: boolean;
  acceptOnEnter?: boolean;
}

export const DEFAULT_MODAL_OPTIONS: ModalOptions = {
  centered: true,
  backdrop: { dismissOnClick: true },
  dismissOnEscape: true,
  acceptOnEnter: false,
};
